import { render, staticRenderFns } from "./ConversationStatistical.vue?vue&type=template&id=c6315282&scoped=true"
import script from "./ConversationStatistical.vue?vue&type=script&lang=js"
export * from "./ConversationStatistical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6315282",
  null
  
)

export default component.exports